import { Utils } from '@pacem/pacem-core';
//namespace Pacem.Drawing3D {
export function NotifyChange(callback) {
    return (target, prop, descriptor) => {
        const backingField = `_${prop}_${Utils.uniqueCode()}_backingField`;
        function getter() {
            return this[backingField];
        }
        function setter(val) {
            if (val !== this[backingField]) {
                const old = this[backingField];
                this[backingField] = val;
                callback.call(this, prop, old, val);
            }
        }
        //if (delete target[prop]) {
        Object.defineProperty(target, prop, {
            get: function () {
                return getter.call(this);
            },
            set: function (val) {
                setter.call(this, val);
            },
            enumerable: true,
            configurable: false
        });
        //}
    };
}
